import { createSelector } from "@reduxjs/toolkit";

export const selectNotificationsState = (state) => state.notifications || {};

const selectNotificationsItems = (state) =>
  selectNotificationsState(state).items;

export const selectNotifications = createSelector(
  [selectNotificationsItems],
  (items) => items || []
);

export const selectNotificationsStatus = (state) =>
  selectNotificationsState(state).status || "idle";

export const selectNotificationsError = (state) =>
  selectNotificationsState(state).error || null;

export const selectUnreadCount = (state) =>
  Number(selectNotificationsState(state).unreadCount || 0);

export const selectUnreadNotifications = createSelector(
  [selectNotifications],
  (notifications) => notifications.filter((n) => !n.read)
);

// Memoized selector factory for latest notifications
const latestNotificationsCache = new Map();
export const selectLatestNotifications = (count = 8) => {
  if (!latestNotificationsCache.has(count)) {
    latestNotificationsCache.set(
      count,
      createSelector(
        [selectNotifications],
        (notifications) => notifications.slice(0, count)
      )
    );
  }
  return latestNotificationsCache.get(count);
};
